import { RespondentDemographic } from '@keyops-cep/api-client';
export interface AnswerComponents {
  value: string | string[] | number;
  aggregateQuestionSurveySparrowId: string;
  questionComponentSurveySparrowId: string;
}

export interface ISurveySparrowAnswerData {
  id: string;
  createdAt: string;
  updatedAt: string;
  questionId: string;
  choiceId?: string;
  value?: string | string[] | boolean | number;
  components?: AnswerComponents[];
  tenantId: string;
  responseId: string;
}

export interface AnswerDataWithDemographic extends ISurveySparrowAnswerData {
  demographics: RespondentDemographic[];
}

// MaxDiff answer data
export interface MaxDiffAnswerComponents {
  value: {
    best: string;
    worst: string;
    items_shown: string[];
    step: string;
    Skip: boolean;
  };
  aggregateQuestionSurveySparrowId: string;
  questionComponentSurveySparrowId: string;
}

const isRecord = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null;

const isStringArray = (v: unknown): v is string[] =>
  Array.isArray(v) && v.every((x) => typeof x === 'string');

// MaxDiff answer validator
export const isMaxDiffAnswerComponent = (
  c: unknown
): c is MaxDiffAnswerComponents =>
  isRecord(c) &&
  typeof c['questionComponentSurveySparrowId'] === 'string' &&
  isRecord(c['value']) &&
  typeof c['value']['best'] === 'string' &&
  typeof c['value']['worst'] === 'string' &&
  isStringArray(c['value']['items_shown']) &&
  typeof c['value']['step'] === 'string' &&
  typeof c['value']['Skip'] === 'boolean';

export type MaxDiffAnswerDataWithDemographic = Omit<
  AnswerDataWithDemographic,
  'components'
> & {
  components?: MaxDiffAnswerComponents[];
};

export interface Respondent {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  value: string;
  surveySparrowId: string;
  tenantId: string;
  responseId: string;
}
